// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"667":"0fccbfd7","977":"608bbf11"}[chunkId] + ".chunk.js";
};